import { Link, SxProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { PatternFormat } from 'react-number-format';

const PhoneNumberLink = (props: {
  formattedPhoneNumber?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  phoneNumber?: string;
  sx?: SxProps;
}) => {
  const { formattedPhoneNumber, onClick, phoneNumber } = props;
  const theme = useTheme();

  return (
    <Link
      aria-label="Call Agent"
      data-testid="PhoneNumberLink"
      href={`tel:${phoneNumber}`}
      onClick={(e) => {
        if (onClick) {
          onClick(e);
        }
      }}
      sx={{
        color: theme.palette.primary.main,
        textDecoration: 'none',
        fontWeight: 700,
        lineHeight: '17px',
        fontSize: { mobile: 16, tablet: 18 },
        width: 'fit-content',
        ...props.sx,
      }}
    >
      <PatternFormat
        value={formattedPhoneNumber || phoneNumber}
        displayType="text"
        format="###.###.####"
      />
    </Link>
  );
};

export default PhoneNumberLink;
